export const ROLE_ADMIN = "admin";
export const ROLE_CASHIER = "cashier";
export const ROLE_LOAN_OFFICER = "collections_officer";

const NAV_ACCESS_BY_ROLE = {
  [ROLE_ADMIN]: ["dashboard", "customers", "motorcycles", "sales", "debts", "payments", "admins", "reports"],
  [ROLE_CASHIER]: ["dashboard", "debts", "payments", "customers", "motorcycles", "sales"],
  [ROLE_LOAN_OFFICER]: ["dashboard", "debts", "customers"],
};

const ROUTE_SECTION_BY_SUB_ITEM = {
  "create-customer": "customers",
  "create-motorcycle": "motorcycles",
  "create-sale": "sales",
  "create-payment": "payments",
  "create-admin": "admins",
  "customer-options": "customers",
  "motorcycle-options": "motorcycles",
  "sale-options": "sales",
  "debt-options": "debts",
  "payment-options": "payments",
  "admin-options": "admins",
};

export function normalizeRole(role) {
  if (role === "loan_officer") {
    return ROLE_LOAN_OFFICER;
  }

  return role || ROLE_ADMIN;
}

export function getUserRole(user) {
  return normalizeRole(user?.role);
}

export function formatAdminRole(role) {
  const normalizedRole = normalizeRole(role);

  if (normalizedRole === ROLE_ADMIN) return "Administrator";
  if (normalizedRole === ROLE_CASHIER) return "Cashier";
  if (normalizedRole === ROLE_LOAN_OFFICER) return "Loan Officer";

  return String(normalizedRole)
    .split("_")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join(" ");
}

export function getAllowedNavItems(user) {
  const role = getUserRole(user);
  return NAV_ACCESS_BY_ROLE[role] || NAV_ACCESS_BY_ROLE[ROLE_ADMIN];
}

export function canAccessNavItem(user, navItem) {
  return getAllowedNavItems(user).includes(navItem);
}

export function getDefaultNavItem(user) {
  const allowedNavItems = getAllowedNavItems(user);
  return allowedNavItems[0] || "dashboard";
}

export function getAccessibleNavTarget(user, nav = {}) {
  const targetSection =
    nav.item === "view" || nav.item === "side-view"
      ? ROUTE_SECTION_BY_SUB_ITEM[nav.subItem]
      : nav.item;

  if (!targetSection || canAccessNavItem(user, targetSection)) {
    return nav;
  }

  return { item: getDefaultNavItem(user) };
}

export function canManagePayments(user) {
  const role = getUserRole(user);
  return role === ROLE_ADMIN || role === ROLE_CASHIER;
}

export function isLoanOfficer(user) {
  return getUserRole(user) === ROLE_LOAN_OFFICER;
}

export function isDebtAssignedToUser(debt, user) {
  const currentUserId = String(user?.id || user?.uuid || "").toLowerCase();
  const currentUserName = String(user?.fullname || user?.name || "").toLowerCase();

  const assignedOfficerId = String(
    debt?.collections_officer ||
      debt?.collectionsOfficer ||
      debt?.assignedTo ||
      debt?.officerId ||
      ""
  ).toLowerCase();

  const assignedOfficerName = String(
    debt?.officerName ||
      debt?.collectionsOfficerName ||
      debt?.assignedOfficerName ||
      ""
  ).toLowerCase();

  if (currentUserId && assignedOfficerId === currentUserId) {
    return true;
  }

  if (currentUserName && assignedOfficerName === currentUserName) {
    return true;
  }

  return false;
}
